//引入Vue核心库
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
import getters from './getters'
//应用Vuex插件
Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
//新建vuex的store实例
//store基本上就是一个容器，它包含着你的应用中大部分的状态 (state)
const store = new Vuex.Store({
  modules,
  getters
})


export default store
